/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-04-07 12:53:15
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-04-16 22:00:46
 * @FilePath: \website\src\utils\jsfunction-handler.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import addParams from '@/views/manage/design/addParams';
import { MessagePlugin as Message } from 'tdesign-vue-next';

export function execMethod(funcStr, paramObj) {
    let resData = paramObj;
    if (typeof paramObj === 'string') {
        try {
            resData = JSON.parse(paramObj)
        } catch (e) {
            resData = paramObj;
        }
    }
    if (!funcStr) {
        return resData
    }
    try {
        const Fn = new Function('resData', funcStr)
        return Fn(resData)
    } catch (e) {
        console.error(e)
        Message.error('脚本函数执行错误')
        return undefined
    }
}

/**
 *  接口返回值格式化，便于json编辑框显示
 */
export function resFormat(data) {
    let dataStr;
    if (typeof data === 'object') {
        dataStr = JSON.stringify(data)
    } else if (typeof data === 'undefined') {
        return 'undefined'
    } else {
        dataStr = data.toString();
    }
    try {
        return JSON.stringify(JSON.parse(dataStr), null, 2)
    } catch (e) {
        return dataStr
    }
}

export function copyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
}

// 获取地址栏参数
export function getURLParam(name) {
    const reg = new RegExp(`\\b${name}=([^&]*)`, 'i');
    const match = window.location.search.match(reg);
    return match ? decodeURIComponent(match[1]) : null;
}
// 与父页面通讯    默认跳回父页面路由
export function postMessage(data = {action:'returnToParentPage', params:{url:''},targetOrigin : '*'}) {
    window.parent.postMessage({
        action: data.action,
        // 可选，传递额外数据给父页面
        data: data.params
    }, data.targetOrigin);
}
